import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { TTL } from "../../Lib/Utils/TTL";
import { IApiResponse } from "../../Orchestrator/Types/Index";
import { ISaveServiceRequestPayload, ISaveServiceRequestResponse, IServiceRequestCategory } from "../../Orchestrator/Types/Interface/IServiceRequest";

export async function getServiceRequestCategoriesAPI(context: string): Promise<IApiResponse<{ serviceRequestCategories: IServiceRequestCategory[] }>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = `${ENDPOINTS.getServiceRequestCategories}?context=${context}`;
    return await apiRequest<{ serviceRequestCategories: IServiceRequestCategory[] }>(endpoint, 'GET');
}

export async function postServiceRequest(
    saveServiceRequestPayload: ISaveServiceRequestPayload,
): Promise<IApiResponse<ISaveServiceRequestResponse>> {
    const ENDPOINTS = await getEndpoints();
    const endpoint = ENDPOINTS.saveServiceRequestAPI
    return await apiRequest<ISaveServiceRequestResponse>(endpoint, 'POST', {
        body: JSON.stringify(saveServiceRequestPayload),
    });
}